<template>
  <div class="industrialcomputer-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('industrialcomputer_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-server</v-icon>{{$t('profile.industrialcomputer.industrialcomputers')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <IndustrialComputerFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import IndustrialComputerFilterForm from '../../components/industrialcomputer/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'IndustrialComputerList',
  servicePrefix: 'IndustrialComputer',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    IndustrialComputerFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.industrialcomputer.name'), value: 'name' },
        { text: this.$t('profile.industrialcomputer.model'), value: 'model' },
        { text: this.$t('profile.industrialcomputer.version'), value: 'version' },
        { text: this.$t('profile.industrialcomputer.parent'), value: 'parent.name' },
        { text: this.$t('global.archive'), value: 'archive'},
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('industrialcomputer', {
      items: 'list'
    }),
    ...mapFields('industrialcomputer', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('industrialcomputer', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
